<template>
  <div class="flex flex-col flex-1 overflow-hidden">
    <div class="flex flex-1 overflow-auto">
      <ChatConversationWrapV2
        v-if="isEnabledWidgetV2"
        :grouped-messages="groupedMessages"
      />
      <conversation-wrap v-else :grouped-messages="groupedMessages" />
    </div>

    <ChatFooterV2 v-if="isEnabledWidgetV2" />
    <ChatFooter v-else class="px-5" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { useFlipper } from 'widget/composables/useFlipper';

import ChatFooter from '../components/ChatFooter.vue';
import ConversationWrap from '../components/ConversationWrap.vue';

// V2
import ChatFooterV2 from 'widget/v2/components/message-parts/ChatFooter.vue';
import ChatConversationWrapV2 from 'widget/v2/components/message-parts/ChatConversationWrap.vue';

export default {
  components: {
    ChatFooter,
    ConversationWrap,
    ChatFooterV2,
    ChatConversationWrapV2,
  },
  setup() {
    const { isEnabled } = useFlipper();
    return { isFlipperEnabled: isEnabled };
  },
  computed: {
    ...mapGetters({
      groupedMessagesV1: 'conversation/getGroupedConversation',
      groupedMessagesV2: 'conversation/getGroupedConversationV2',
    }),
    isEnabledWidgetV2() {
      return this.isFlipperEnabled('chat_widget_v2').value;
    },
    groupedMessages() {
      return this.isEnabledWidgetV2
        ? this.groupedMessagesV2
        : this.groupedMessagesV1;
    },
  },
  mounted() {
    this.$store.dispatch('conversation/setUserLastSeen');
    if (this.isEnabledWidgetV2) {
      this.$store.dispatch('conversation/showWelcomeMessage', { delay: 1000 });
    }
  },
  beforeDestroy() {
    if (this.isEnabledWidgetV2) {
      this.$store.dispatch('conversation/cleanupWelcomeMessage');
    }
  },
};
</script>
